import type { LoadingManager } from '@seddi/three';
import log from 'loglevel';

import { ResourceManager } from './resourceManager';
import { load } from './stitchesTexturesLoader';
import type { StitchesTextures } from './stitchesTexturesTypes';

export type StitchesTexturesDesc = {
  id: string;
  url: string;
  urlBinary: string;
};

/**
 * Stitches textures resources context.
 */
export class StitchesTexturesContext extends ResourceManager<StitchesTextures> {
  /**
   * Loading manager.
   */
  readonly manager: LoadingManager;

  constructor(manager: LoadingManager) {
    super();
    this.manager = manager;
  }

  /**
   * Load stitches textures.
   * @param desc - Descriptor.
   */
  async loadAsync(desc: StitchesTexturesDesc): Promise<StitchesTextures | undefined> {
    if (this.find(desc.id)) {
      log.warn(`LogosContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const value = await load(desc.url, desc.urlBinary, this.manager);
    item.status = 'ready';
    item.value = value;

    if (this.onLoad) {
      this.onLoad(desc.id, 'StitchesTextures');
    }

    return value;
  }
}
